interface RoundConfig {
  mode?: "round" | "ceil" | "floor";
  fractionalDigits?: number;
}

const round = (number: number, config: RoundConfig = {}) => {
  const { mode = "round", fractionalDigits = 0 } = config;
  const multiplier = Math.pow(10, fractionalDigits);
  const fun = Math[mode];
  return fun((number + Number.EPSILON) * multiplier) / multiplier;
};

const decimalToFraction = (decimal: number) => {
  if (decimal < 0 || decimal > 1 || Number.isNaN(decimal)) {
    console.error("Value must be between 0 and 1");
    return undefined;
  }
  const precision = 16;

  if (decimal < 1 / precision) {
    return { numerator: 1, denominator: 16 };
  }

  // Round down so that we don't have cases where numerator and denominator are equal
  const numerator = Math.floor(decimal * precision);
  const denominator = 16;

  const gcd = (a: number, b: number): number => (b === 0 ? a : gcd(b, a % b));
  const divisor = gcd(numerator, denominator);

  const simplifiedNumerator = numerator / divisor;
  const simplifiedDenominator = denominator / divisor;

  if (simplifiedDenominator === 1) {
    return undefined;
  }

  return { numerator: simplifiedNumerator, denominator: simplifiedDenominator };
};

export const MathUtils = {
  round,
  decimalToFraction,
};
